import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  flatButton: { padding: 0, wordWrap: 'none' },
  clickable: {
    color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    fontWeight: isKiteUser ? '400' : '600',
    textDecoration: 'none',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
}));
